"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformAnalyticsStore = exports.PlatformAnalyticsStoreImpl = void 0;
var platform_analytics_factory_1 = require("./platform-analytics-factory");
var PlatformAnalyticsStoreImpl = /** @class */ (function () {
    function PlatformAnalyticsStoreImpl() {
    }
    PlatformAnalyticsStoreImpl.prototype.resetAnalyticsForNewPage = function () {
        this.platformAnalytics = (0, platform_analytics_factory_1.createPlatformAnalytics)();
    };
    PlatformAnalyticsStoreImpl.prototype.getPlatformAnalytics = function () {
        if (this.platformAnalytics === undefined) {
            this.platformAnalytics = (0, platform_analytics_factory_1.createPlatformAnalytics)();
        }
        return this.platformAnalytics;
    };
    PlatformAnalyticsStoreImpl.prototype.setPlatformAnalytics = function (platformAnalytics) {
        this.platformAnalytics = platformAnalytics;
    };
    return PlatformAnalyticsStoreImpl;
}());
exports.PlatformAnalyticsStoreImpl = PlatformAnalyticsStoreImpl;
exports.PlatformAnalyticsStore = new PlatformAnalyticsStoreImpl();
//# sourceMappingURL=platform-analytics-store.js.map